import React from 'react';
import Switch from 'react-switch';

import {teamInputs, validEmail, validPhone} from '../utils';
import {Button, Input, InputError, InputRadioGroup, Modal, Section} from './';

const FormAdmin = ({
  companyId,
  isArchived,
  isOpenModalToArchive,
  changeIsOpenModalToArchive,
  services,
  changeServices,
  changeCredits,
  changeUnlimited,
  addTeammate,
  removeTeammate,
  changeTeam,
  team,
  companyName,
  changeCompanyName,
  changeDate,
  endOfUseDate,
  isOpen,
  changeIsOpen,
  handleSubmit,
  handleArchivedCompany,
  changeSelectedEmail,
  selectedEmail,
}) => {
  const isDisabled = () => {
    let teamFieldIsmepty = false;
    team.forEach((t) => {
      if (Object.values(t).some((v) => v.length === 0)) {
        return (teamFieldIsmepty = true);
      }
    });
    if (
      companyName.length === 0 ||
      endOfUseDate.length === 0 ||
      services.some((s) => s.isSelected && s.credits.length === 0) ||
      services.every((s) => !s.isSelected) ||
      teamFieldIsmepty ||
      team.some((s) => !validEmail(s.email) || !validPhone(s.phone))
    )
      return true;
  };

  return (
    <form>
      <div>
        <div className={isArchived ? 'form-container' : ''}>
          <Section title="Entreprise">
            <div className="input-form-grid">
              <Input
                label="Nom *"
                name="name"
                placeholder="LeroyMerlin"
                type="text"
                value={companyName}
                handleChange={(e) => {
                  changeCompanyName(e.target.value);
                }}
                empty={companyName.length === 0}
                disabled={isArchived}
                dark
              />
            </div>
          </Section>
          <Section title="Equipe">
            {team.map((t, teammateIndex) => (
              <div key={teammateIndex} className="input-team-group">
                <div className="input-form-grid">
                  {teamInputs.map((input) => (
                    <div key={input.name} className="input-form-grid-col">
                      <Input
                        label={input.label}
                        name={input.name}
                        value={t[input.name]}
                        placeholder={input.placeholder}
                        type={input.type}
                        handleChange={(e) => changeTeam(e, teammateIndex)}
                        empty={t[input.name].length === 0}
                        invalidEmail={t.email && !validEmail(t.email)}
                        invalidPhone={t.phone && !validPhone(t.phone)}
                        disabled={isArchived}
                        dark
                      />
                    </div>
                  ))}
                </div>
                {!isArchived && team.length > 1 && (
                  <Button
                    type="button"
                    label="Supprimer ce collaborateur"
                    onClick={(e) => removeTeammate(e, teammateIndex)}
                    removeTeammate
                  />
                )}
              </div>
            ))}
            <Button
              type="button"
              label="Ajouter un collaborateur"
              icon={<i className="fas fa-plus-circle" />}
              onClick={(e) => addTeammate(e)}
              addTeammate
              disabled={isArchived ? true : false}
            />
          </Section>
          <Section title="Abonnement">
            <div className="subscription-container">
              <div>
                <Input
                  label="Date de fin d'engagement *"
                  name="endDataOfUse"
                  placeholder="LeroyMerlin"
                  type="date"
                  min={new Date().toISOString().split('T')[0]}
                  value={endOfUseDate}
                  handleChange={(e) => {
                    changeDate(e.target.value);
                  }}
                  empty={endOfUseDate.length === 0}
                  disabled={isArchived}
                  dark
                />
              </div>
              <div className="subscription-service-container">
                <p className="input-form">Sélection des services *</p>
                <InputError empty={services.every((s) => !s.isSelected)} />
                {services.map((service, index) => (
                  <div key={service.value} className="input-form-services">
                    <label className="checkbox">
                      <input
                        name="service"
                        type="checkbox"
                        checked={service.isSelected}
                        value={service.value}
                        onChange={(e) => changeServices(e, index)}
                        className="input-form-checkbox"
                        disabled={isArchived}
                      />
                      {service.label}
                    </label>
                    <div className="input-group-services">
                      <Input
                        name="credits"
                        type="number"
                        min="0"
                        value={service.credits}
                        placeholder="500 crédits *"
                        handleChange={(e) => changeCredits(e, index)}
                        className="input-form-field-credit"
                        hidden={!service.isSelected}
                        disabled={service.unlimited || isArchived}
                        empty={service.isSelected && service.credits.length === 0}
                      />
                      {service.isSelected && (
                        <label className="input-switch">
                          <Switch
                            onChange={(e) => changeUnlimited(e, index)}
                            checked={service.unlimited}
                            height={20}
                            width={35}
                            onColor="#2A3FBC"
                            offColor="#09092D"
                            checkedIcon={false}
                            uncheckedIcon={false}
                            disabled={isArchived}
                          />
                          <span>Illimité</span>
                        </label>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Section>
        </div>
        {companyId ? (
          <div className="container-buttons-form-admin">
            {!isArchived && (
              <Button
                label="Enregistrer les modifcations"
                light
                onClick={handleSubmit}
                disabled={isDisabled()}
              />
            )}
            <Button
              label={!isArchived ? 'Archiver' : 'Récupérer ce compte'}
              light={isArchived && 'light'}
              dark={!isArchived && 'dark'}
              onClick={(e) => {
                e.preventDefault();
                changeIsOpenModalToArchive(true);
              }}
            />
          </div>
        ) : (
          <div className="container-buttons-form-admin">
            <Button
              type="button"
              label="Créer le compte"
              onClick={() => changeIsOpen(true)}
              disabled={isDisabled()}
              light
            />
          </div>
        )}
        {isOpenModalToArchive && (
          <Modal
            closeModal={() => changeIsOpenModalToArchive(false)}
            handleClick={() => handleArchivedCompany(!isArchived)}
            buttonType="submit"
            subtitle={
              isArchived
                ? `Êtes-vous sûr de vouloir récupérer le compte ${companyName} ?`
                : `Êtes-vous sûr de vouloir archiver le compte ${companyName} ?`
            }
          />
        )}
        {isOpen && (
          <Modal
            closeModal={() => changeIsOpen(false)}
            handleClick={(e) => handleSubmit(e)}
            buttonType="submit"
            disabledButton={!selectedEmail}
            title="Finaliser la création du compte"
            subtitle="Envoi des identifiants de connexion :"
          >
            <InputRadioGroup
              title="Veuillez choisir un collaborateur"
              values={team}
              inputName="selectedEmail"
              handleChange={changeSelectedEmail}
              selectedOption={selectedEmail}
            />
          </Modal>
        )}
      </div>
    </form>
  );
};

export default FormAdmin;
